<template lang="">
    <v-chip
        label
        small
        :color="color"
        :text-color="textColor"
    >
        {{ label }}
    </v-chip>
</template>
<script>
export default {
    props: ['status'],

    computed: {
        label() {
            console.log(this.status, 'status')
            switch (this.status) {
                case true:
                    return this.$t('active');
                case false:
                    return this.$t('inactive');
                default:
                    return this.$t(this.status);
                    break;
            }
        },

        color() {
            switch (this.status) {
                case 'active':
                    return '#c9f7f5';
                case true:
                    return '#c9f7f5';
                case 'inactive':
                    return '#ffe2e5';
                case false:
                    return '#ffe2e5';
                case 'pending':
                    return '#e1f0ff';
                default:
                    return this.$t(this.status);
            }
        },

        textColor() {
            switch (this.status) {
                case 'active':
                    return '#1bc5bd';
                case true:
                    return '#1bc5bd';
                case 'inactive':
                    return '#f64e60';
                case false:
                    return '#f64e60';
                case 'pending':
                    return '#3699ff';
                default:
                    return this.$t(this.status);
            }
        }
    }
}
</script>